import { refreshSession, type AuthenticatedPayload } from './api/auth';

/**
 * Garante **uma** rotação de refresh por vez em toda a aba.
 *
 * O refresh é rotativo com detecção de reuso: apresentar um token já rotacionado revoga
 * a família inteira, porque é o sinal clássico de token roubado. Duas chamadas
 * simultâneas produzem exatamente esse sinal — a primeira rotaciona, a segunda chega com
 * o token velho — e a sessão legítima cai.
 *
 * E duas chamadas simultâneas acontecem no caminho mais comum que existe: o `StrictMode`
 * do React monta os efeitos duas vezes em desenvolvimento, então **recarregar a página**
 * derrubava a própria sessão. Fora do StrictMode o mesmo ocorreria com duas requisições
 * disparadas ao mesmo tempo depois de o access token expirar.
 *
 * A promessa em curso fica no módulo, e não em estado do React, justamente para
 * sobreviver às duas montagens — estado é recriado, o módulo não.
 *
 * Isto **não** substitui a detecção de reuso no servidor: ela continua sendo a defesa, e
 * está certa. Aqui só evitamos que o cliente produza o sinal por conta própria.
 */
let inFlight: Promise<AuthenticatedPayload> | null = null;

export function refreshSessionOnce(): Promise<AuthenticatedPayload> {
  inFlight ??= refreshSession().finally(() => {
    // Liberado no fim, com sucesso ou erro: a próxima tentativa legítima — quinze
    // minutos depois — precisa poder rotacionar de novo.
    inFlight = null;
  });

  return inFlight;
}
